module.exports = __webpack_public_path__ + "img/faqs-bg-header.da107d77.webp";